<ng-container *ngFor="let content of page.content" [ngSwitch]="content.__component">
  <app-image-slider *ngSwitchCase="'a-content-element.slider'" [data]="$any(content)"></app-image-slider>
  <app-image-grid *ngSwitchCase="'a-content-element.teaser-panel'" [data]="$any(content)"></app-image-grid>
  <app-blog-slider *ngSwitchCase="'a-content-element.slider-with-page-teaser'" [data]="$any(content)"></app-blog-slider>
  <app-videos *ngSwitchCase="'a-content-element.videos'" [data]="$any(content)"></app-videos>
  <app-category-grid
    *ngSwitchCase="'a-content-element.category-panel'"
    [data]="$any(content)"
    [categoryCount]="page.categoryCount"
  ></app-category-grid>
  <app-title-and-text *ngSwitchCase="'a-content-element.title-and-text'" [data]="$any(content)"></app-title-and-text>
  <app-faq *ngSwitchCase="'a-content-element.faq'" [data]="$any(content)"></app-faq>
  <app-newsletter *ngSwitchCase="'a-content-element.newsletter'" [data]="$any(content)"></app-newsletter>
  <app-logo-slider *ngSwitchCase="'a-content-element.logo-slider'" [data]="$any(content)"></app-logo-slider>
  <app-portfolio *ngSwitchCase="'a-content-element.portfolio'" [data]="$any(content)"></app-portfolio>
  <app-teaser-carousel *ngSwitchCase="'a-content-element.teaser-carousel'" [data]="$any(content)"></app-teaser-carousel>
  <app-ui-article-slider *ngSwitchCase="'a-content-element.article-slider'" [data]="$any(content)"></app-ui-article-slider>
  <app-product-slider *ngSwitchCase="'a-content-element.product-slider'" [data]="$any(content)"></app-product-slider>

  <app-component-not-configured *ngSwitchDefault [data]="$any(content)"></app-component-not-configured>
</ng-container>
